// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2kaFw","fileBtn":"File_fileBtn__1i4Se","closeBtn":"File_closeBtn__3GB12","fileSelected":"File_fileSelected__1nNF-","disabled":"File_disabled__2_MEj"};